export default __webpack_public_path__ + "static/media/Sodoku.bfaa29c1.png";